import { createSlice } from '@reduxjs/toolkit';
import { createControl } from '../../../../../domain/validation/validation';
import { IFormControl } from '../../../../../ui/forms/interfaces';
import { default as cloneDeep } from 'lodash/cloneDeep';

interface INewCreditCardState{

    // this field is created by zooz secure fields API and its type is unknown
    // https://developers.paymentsos.com/docs/getting-started/collecting-card-information/using-the-secure-fields-form.html
    // https://developers.paymentsos.com/apis-and-sdks/client-library-references/securefieldsreference.html
    zoozSecureFields: any,
    zoozFieldError: string,

    // cart holder name control
    nameOnCardControl: IFormControl,

    // zooz token that is received from
    // secured fields via zooz javascript API
    newCreditCardToken: string,

    rememberMe: boolean,

    // info popups
    rememberMePopupShown: boolean,
    cvvInfoPopupShown: boolean,
}

/**
 * initial state
 */
const initialState: INewCreditCardState = {
    zoozSecureFields: null,
    zoozFieldError: '',

    nameOnCardControl: createControl('nameOnCard', '', {
        required: true
    }),

    newCreditCardToken: '',

    rememberMe: true,

    // info popups
    rememberMePopupShown: false,
    cvvInfoPopupShown: false,
};

const newCreditCardSlice = createSlice({
    name: 'new-credit-card',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setControl(state, action) {
            return {
                ...state,
                [action.payload.controlName]: cloneDeep(action.payload.control),
            }
        },
    }
});

export default newCreditCardSlice;